import { Component, signal } from '@angular/core';
import { AngularModule } from '../../../../../modules/angular.module';
import { NavigationService } from '../../../../../services/navigation.service';
import { StrideSectionReportData } from '@mira-avant/mtlibs';
import { ClassBreakdownComponent } from './class-breakdown/class-breakdown.component';
import { StudentReportsComponent } from './student-reports/student-reports.component';
import { StrideReports } from '../../../../../services/stride-reports';

@Component({
	selector: 'app-stride-section-report',
	standalone: true,
	imports: [AngularModule, ClassBreakdownComponent, StudentReportsComponent],
	templateUrl: './stride-section-report.html',
	styleUrl: './stride-section-report.scss',
})
export class StrideSectionReport {
	report = signal<StrideSectionReportData | undefined>(undefined);

	constructor(
		private strideReportsService: StrideReports,
		private nav: NavigationService
	) {
		this.loadReport();
	}

	private async loadReport() {
		const matrixParams = await this.nav.matrixParams$.getValue();
		const sectionUuid: string = matrixParams['sectionUuid'];

		const data = await this.strideReportsService.getStrideSectionReport$(sectionUuid);
		this.report.set(data);
	}

	selectStudent(studentUuid: string) {
		this.nav.navigateWithMatrix$(['/', 'my', 'reports'], { studentUuid });
	}
}
